export const Paths = {
    scheduleToday: '/customer-portal/v1/dashboard/schedules-today',
    scheduleYesterday: '/customer-portal/v1/dashboard/schedules-yesterday',
    scheduleNext30Days: '/customer-portal/v1/dashboard/schedules-next-30-days',
    schedulePendingToPay: '/customer-portal/v1/dashboard/pending-to-pay',
    schedulePendingToConfirmation: '/customer-portal/v1/dashboard/pending-to-confirmation',
};
